import { render, staticRenderFns } from "./DesocuparDialog.vue?vue&type=template&id=81fbde46&"
import script from "./DesocuparDialog.vue?vue&type=script&lang=js&"
export * from "./DesocuparDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports